// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row {
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;
}

.header {
  height: 67px;
}

.table-inner-container {
  height: 100%;
  overflow: auto;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.suspend-btn {
  margin-left: 0px !important;
}

.table-header {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3 !important;
  z-index: 1;
  vertical-align: middle !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
